import React, { useContext } from "react";
import { TouchableOpacity, StyleSheet, View } from "react-native";

import { Text } from "../../../components/shared/Themed";
import { Switch as RNSwitch } from "react-native-switch";
import { ReadOnlyProps } from "../../../utils/templates";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";

interface Props {
  title?: string;
  isDisplayViewOn: boolean;
  setIsDisplayViewOn: (hasDisplay: boolean) => void;
}

export const ContainerSearchDisplaySwitch: React.FC<Props> = (
  props: ReadOnlyProps<Props>
) => {
  const { isSmallDevice, isMobileDevice } = useContext(DeviceOrientationContext);
  const isMobile = isSmallDevice || isMobileDevice;
  return (
    <View style={styles.pillContainer}>
      <Text style={[styles.title, isMobile && { fontSize: 10 }]}>{props.title}</Text>
      <TouchableOpacity>
        <RNSwitch
          value={props.isDisplayViewOn}
          onValueChange={props.setIsDisplayViewOn}
          disabled={false}
          activeText={"Items"}
          inActiveText={"Containers"}
          circleSize={isMobile ? 20 : 25}
          barHeight={isMobile ? 24 : 30}
          circleBorderWidth={2}
          //Active Props
          backgroundActive={"rgb(47, 149, 220)"}
          circleActiveColor={"#8BCAE5"}
          //InActive Props
          backgroundInactive={"rgba(0, 0, 0, 0.12)"}
          circleInActiveColor={"#A3A4A2"}
          inactiveTextStyle={{ color: "black", fontSize: isMobile ? 10 : 12 }}
          activeTextStyle={{ color: "white", fontSize: isMobile ? 10 : 12 }}
          circleBorderInactiveColor="#858683"
          renderInActiveText={true}
          changeValueImmediately={true}
          innerCircleStyle={{
            alignItems: "center",
            justifyContent: "center",
          }}
          renderActiveText={true}
          switchLeftPx={2}
          switchRightPx={2}
          switchWidthMultiplier={props.isDisplayViewOn ? (isMobile ? 3.5 : 3.75) : (isMobile ? 4.8 : 5.1)}
          switchBorderRadius={30}
          containerStyle={{ marginRight: 0 }}
        />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  pillContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  title: {
    fontSize: 12,
    fontWeight: "600",
    color: "#6B7280",
  },
});
